import React, { useState } from 'react';
import './index.scss';
import Toast1 from './../Toast1/index';
import Toast2 from './../Toast2/index';

const imgs = [
  {
    back: require('./img/back-0-n.png'),
  }, {
    back: require('./img/back-2-n.png'),
  }, {
    back: require('./img/back-1-n.png'),
  }, {
    back: require('./img/back-4-n.png'),
  }, {
    back: require('./img/back-1-n.png'),
  }, {
    back: require('./img/back-4-n.png'),
  }, {
    back: require('./img/back-1-n.png'),
  }, {
    back: require('./img/back-3-n.png'),
  },
];

const Normal = () => {
  const [open, openWhat] = useState(null);

  const close = () => {
    openWhat(null);
  }

  return (
    <ul className='normal'>
      {
        imgs.map((item, index) => (
          <li key={index} className={index === 7 ? 'specail' : ''}>
            <img className='normal-back' src={item.back} />
            <div className='itemContent'>
              {
                (() => {
                  if (index === 7) {
                    return (
                      <React.Fragment>
                        <div className='question'>
                          <div className='normal-title'>
                            <img src={require('./img/8title-n.png')} />
                          </div>
                          <div className='normal-question'>
                            <div className='question-left'>
                              <ul>
                                <li>
                                  <h3 className='question-left-1'>Q：如何成为真爱粉？</h3>
                                  <section className='question-answer'>
                                    <div className='question-answer-left'>
                                      A:
                                    </div>
                                    <div className='question-answer-right'>
                                      在拥有粉丝徽章的主播直播间一次性送出价值1虎牙币的礼物即可加入主播的粉丝团，成为该主播的粉丝；成为粉丝后在公屏发言会带上徽章，每天可以收到粉丝礼包哦!
                                    </div>
                                  </section>
                                </li>
                                <li>
                                  <h3 className='question-left-1'>Q：什么是亲密度？</h3>
                                  <section className='question-answer'>
                                    <div className='question-answer-left'>
                                      A:
                                    </div>
                                    <div className='question-answer-right'>
                                      1元礼物=10亲密度，提升亲密度可以提升粉丝等级，等级越高特权越大!
                                    </div>
                                  </section>
                                </li>
                                <li>
                                  <h3 className='question-left-1'>Q：徽章熄灭了怎么办？</h3>
                                  <section className='question-answer'>
                                    <div className='question-answer-left'>
                                      A:
                                    </div>
                                    <div className='question-answer-right'>
                                      如果连续7天忘记提升亲密度，那么第8天起，徽章就会熄灭，并且无法佩戴；
                                      可以通过赠送礼物、赠送虎粮、粉丝团打卡等方式，提升亲密度，只要亲密度有提升，则徽章恢复点亮；熄灭时间会重新开始计数。
                                    </div>
                                  </section>
                                </li>
                                <li>
                                  <h3 className='question-left-1'>Q：亲密度开始下降了怎么办？</h3>
                                  <section className='question-answer'>
                                    <div className='question-answer-left'>
                                      A:
                                    </div>
                                    <div className='question-answer-right'>
                                      如果连续10天忘记提升亲密度，那么第11天起，亲密度就会衰减，徽章等级下降；亲密度降到0时，徽章就会消失；
                                      可以通过赠送礼物、赠送虎粮、粉丝团打卡等方式，提升亲密度，只要亲密度有提升，衰减就会暂时停止；衰减时间会重新开始计数。
                                    </div>
                                  </section>
                                </li>
                                <li>
                                  <h3 className='question-left-1'>Q：什么是亲密度上限？</h3>
                                  <section className='question-answer'>
                                    <div className='question-answer-left'>
                                      A:
                                    </div>
                                    <div className='question-answer-right'>
                                      每天对单个主播的亲密度增长是有上限的，等级越高上限越高呢~ 粉丝是每天都来看主播直播的真爱粉！
                                    </div>
                                  </section>
                                </li>
                                <li>
                                  <h3 className='question-left-1'>Q：什么是每日粉丝礼包？</h3>
                                  <section className='question-answer'>
                                    <div className='question-answer-left'>
                                      A:
                                    </div>
                                    <div className='question-answer-right'>
                                      粉丝礼包是粉丝的福利，每日粉丝礼包直接发放到包裹，等级越高礼包越丰厚，礼包需要<span>当日送出</span>，否则24点清零；
                                    </div>
                                  </section>
                                </li>

                              </ul>
                            </div>
                            <div className='question-right'>
                              <ul>
                                <li>
                                  <h3 className='question-right-1'>Q：什么是每周首送加成？</h3>
                                  <section className='question-answer'>
                                    <div className='question-answer-left'>
                                      A:
                                    </div>
                                    <div className='question-answer-right'>
                                      每周首送加成是粉丝的专属福利，在每周六到下周五的时间范围内，粉丝在直播间第一次送礼物（一次性送出价值&gt;=0.1虎牙币礼物），可额外获得50亲密度奖励。
                                    </div>
                                  </section>
                                </li>
                                <li>
                                  <h3 className='question-right-1'>Q：什么是钻粉？</h3>
                                  <section className='question-answer'>
                                    <div className='question-answer-left'>
                                      A:
                                    </div>
                                    <div className='question-answer-right'>
                                      钻粉是一套全新的直播间身份象征，用户可在直播间内通过消费或主播授予获得钻，不断消费可提升级钻的等级，获得更多直播间内特权；（目前仅部分主播才有钻粉权限喔！）
                                      <br />
                                      钻粉共有五个级别，从低到高依次是：绿钻-蓝钻-紫钻-粉钻-黑钻；<br />
                                      粉钻与消费金额无关，仅支持由主播手动授予。
                                    </div>
                                  </section>
                                </li>
                                <li>
                                  <h3 className='question-right-1'>Q：如何切换粉丝徽章？</h3>
                                  <section className='question-answer'>
                                    <div className='question-answer-left'>
                                      A:
                                    </div>
                                    <div className='question-answer-right'>
                                      鼠标移到频道内发言框左边的粉丝徽章小牌子上，可以切换或不佩戴任何徽章；
                                    </div>
                                  </section>
                                </li>
                                <li>
                                  <h3 className='question-right-1'>Q：我是主播，如何拥有粉丝?</h3>
                                  <section className='question-answer'>
                                    <div className='question-answer-left'>
                                      A:
                                    </div>
                                    <div className='question-answer-right'>
                                      达到认证等级的主播可到进入个人中心/主播设置/徽章昵称下开通粉丝徽章，官方会在24小时内进行审核；
                                    </div>
                                  </section>
                                </li>
                                <li>
                                  <h3 className='question-right-2'>Q：主播的粉丝徽章可以申请任何词语么?有什么标准呢?</h3>
                                  <section className='question-answer'>
                                    <div className='question-answer-left'>
                                      A:
                                    </div>
                                    <div className='question-answer-right'>
                                      ① 粉丝徽章昵称需与主播的历史常用昵称相关，注意！！每个主播仅有1次修改粉丝徽章昵称的机会，请谨慎使用！
                                      <br />
                                      ② 粉丝徽章昵称不可与其他主播的粉丝徽章昵称重复；
                                      <br />
                                      ③ 粉丝徽章昵称不可为网络平台专属词汇（如：帝皇、直播）；
                                      <br />
                                      ④ 带有广告意图的粉丝徽章昵称均不予以通过；
                                      <br />
                                      ⑤ 粉丝昵称不可使用涉政、涉黄、涉暴等敏感词汇；
                                      <br />
                                      ⑥ 粉丝徽章格式为2个汉字或4个数字、4个英文，也可中英文结合，如：【Miss】【楚河】【Kaer】
                                    </div>
                                  </section>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </React.Fragment>
                    )
                  }
                  if (index === 4) {
                    return (
                      <React.Fragment>
                        <div className={'normal-left'}>
                          <img src={require(`./img/${index + 1}left-n.png`)} />
                        </div>
                        <div className={'normal-right'}>
                          <div className='normal-right-5'>
                            <img src={require('./img/5right-n.png')} />
                            <p className='clicktopText'>每日上线的粉丝可以收到系统的礼包,<br />粉丝等级越高, 礼包内的礼物数量就越多!</p>
                            <p className='clickText'
                              onClick={
                                () => {
                                  openWhat(2);
                                }
                              }
                            >{'>>'}查看等级与礼包对照表</p>
                          </div>
                        </div>
                      </React.Fragment>
                    )
                  }
                  if (index === 5) {
                    return (
                      <React.Fragment>
                        <div className={'normal-left'}>
                          <div className='normal-left-6'>
                            <img src={require('./img/6left-n.png')} />
                            <p className='clicktopText'>针对粉丝专门设置一个榜单,最近7天亲<br />密度上升越多，排名越靠前哦! 赶紧提升<br />自己的亲密度吧!</p>
                            <p className='clickText'
                              onClick={
                                () => {
                                  openWhat(1);
                                }
                              }
                            >{'>>'}查看亲密度与等级对照表</p>
                          </div>
                        </div>
                        <div className={'normal-right'}>
                          <img src={require(`./img/${index + 1}right-n.png`)} />
                        </div>
                      </React.Fragment>
                    )
                  }
                  return (
                    <React.Fragment>
                      <div className={'normal-left'}>
                        <img src={require(`./img/${index + 1}left-n.png`)} />
                      </div>
                      <div className={'normal-right'}>
                        <img src={require(`./img/${index + 1}right-n.png`)} />
                      </div>
                    </React.Fragment>
                  )
                })()
              }
            </div>
          </li>
        ))
      }
      {
        open === 1 &&
        <Toast1
          close={close}
        />
      }
      {
        open === 2 &&
        <Toast2
          close={close}
        />
      }
    </ul>
  )
}
export default Normal;
